<template>
  <div>
    <page-header
      :page="pageConfig"
      :actions="actions"
      has-return
      right-side-class="col-sm-12 col-md-4 d-flex justify-content-end align-items-center actions text-right"
    />
    <queue-report-status
      v-if="queuedReportInfo"
      :report-info="queuedReportInfo"
      @onCancel="onCancelHandler"
      @onDownload="onDownloadHandler"
    />
    <filter-manager
      ref="filterManagerRef"
      v-model="filterModel"
      search-container-class="mt-4 pt-2"
      :filters="filtersConfig"
      :openAdvanced="openAdvanced"
      @search="onSearchHandler($event, 1)"
      @academicYear="onAcademicYearChangeHandler"
      @center="onCenterChangeHandler"
      @municipality="onMunicipalityChangeHandler"
      @stipulation="onStipulationChangeHandler"
    />
    <div v-for="(item, index) in result" :key="`result-row-${index}`">
      <result-row
        :management-types="filterOptions.managementTypes"
        :status-reasons="filterOptions.statusReasons"
        :value="item"
        @on-save-manage-information="onSaveManageInformationHandler"
        @on-pending-approval-change-status="onPendingApprovalChangeStatusHandler"
      />
    </div>
    <pagination
      v-if="showPagination"
      :data="pagination"
      show-text
      @pagination-go-page="goToPageHandler"
    />
  </div>
</template>

<script>
import storeMixin from "utils/mixins/storeGenerator";
import alertMixin from "utils/mixins/alert.mixin";
import PageHeader from "PageHeader";
import FilterManager from "FilterManager";
import Pagination from "pagination";
import ResultRow from "./components/ResultRow";
import {
  getInitFilters as _getInitFilters,
  getCenters as _getCenters,
  getMunicipalities as _getMunicipalities,
  getSchools as _getSchools,
  searchRelatedServices as _searchRelatedServices,
  accomplishCompliance as _accomplishCompliance,
  excludeCompliance as _excludeCompliance,
  denyCompliance as _denyCompliance,
  pendingApprovalStatusCompliance as _pendingApprovalStatusCompliance,
  queueComplianceManagementReport as _queueComplianceManagementReport,
  downloadQueuedReport as _downloadQueuedReport,
  cancelQueuedReport as _cancelQueuedReport,
  hasAdvancedFilter as _hasAdvancedFilter
} from "@/modules/compliance-rlv/api.js";
import { relatedServiceViewTypes,
         stipulationTypes } from "@/utils/constants/pei/compliance-rlv/relatedServiceStatus";
import hubService, {serverEvents} from "@/services/signalr/hubService";
import QueueReportStatus from "@/views/pei/complianceRlv/components/QueueReportStatus.vue";
import {QueueReportStatuses} from "@/utils/constants/queue/queueReportStatuses";
const STORE_MODULE_NAME = "complianceRelatedServiceModule";
const DEFAULT_PAGE_SIZE = 10;

export default {

  name: "ComplianceRelatedServiceMain",
  mixins: [storeMixin, alertMixin],
  components: {
    QueueReportStatus,
    PageHeader,
    FilterManager,
    ResultRow,
    Pagination
  },
  data: () => ({
    queuedReportInfo: null,
    openAdvanced: false,
    moduleName: STORE_MODULE_NAME,
    filterModel: {
      academicYear: null,
      stipulation: null,
      status: null,
      center: null,
      municipality: null,
      school: null,
      service: null
    },
    filterOptions: {
      academicYears: [],
      stipulations:[],
      status: [],
      centers: [],
      municipalities: [],
      schools: [],
      managementTypes: [],
      statusReasons: [],
      services: [],
    },
    result: [],
    pagination: {
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 1,
      count: 0,
      pageSize: DEFAULT_PAGE_SIZE
    }
  }),
  computed: {
    pageConfig() {
      return {
        icon: "fas fa-user-edit",
        title: "Cumplimiento con Servicios de Estudiante (RLV)",
        routes: [
          "Inicio",
          "PEI",
          "Cumplimiento con Servicios de Estudiante (RLV)"
        ]
      };
    },
    actions() {
      return [
        {
          name: "Informe de Gestiones",
          icon: "far fa-download",
          variant: "outline-success",
          text: "Informe de Gestiones",
          visible: this.canQueueManagementReport,
          click: this.queueManagementReport
        }
      ];
    },
    canQueueManagementReport() {
      return this.$store.getters.HasPermission(
        "stipulations.managementreport"
      ) && (this.queuedReportInfo == null || this.queuedReportInfo.statusId === QueueReportStatuses.Failed || this.queuedReportInfo.statusId === QueueReportStatuses.Completed);
    },
    filtersConfig() {
      return [
        {
          name: "academicYear",
          component: "CustomDropDown",
          label: "Año Académico:",
          value: this.filterModel.academicYear,
          options: this.filterOptions.academicYears,
          placeholder: "Seleccionar",
          fieldName: "description",
          fieldKey: "id",
          class: "col-12 col-md-4",
          clearable: true,
          validations: this.filterModel.studentSieId ? "" : "required",
          error: "El año académico es requerido."
        },
        {
          name: "stipulation",
          component: "CustomDropDown",
          label: "Estipulación:",
          value: this.filterModel.stipulation,
          options: this.filterOptions.stipulations,
          placeholder: "Seleccionar",
          fieldName: "name",
          fieldKey: "id",
          class: "col-12 col-md-4",
          clearable: true,
          validations: this.filterModel.studentSieId ? "" : "required",
          error: "La Estipulación es requerida."
        },
        {
          name: "status",
          component: "CustomDropDown",
          label: "Estatus:",
          value: this.filterModel.status,
          options: this.filterOptions.status,
          placeholder: "Seleccionar",
          fieldName: "name",
          fieldKey: "id",
          class: "col-12 col-md-4"
        },
        {
          name: "center",
          component: "CustomDropDown",
          label: "Centro:",
          value: this.filterModel.center,
          options: this.filterOptions.centers,
          placeholder: "Seleccionar",
          fieldName: "name",
          fieldKey: "id",
          class: "col-12 col-md-3",
          isAdvanced: true
        },
        {
          name: "municipality",
          component: "CustomDropDown",
          label: "Municipio:",
          value: this.filterModel.municipality,
          options: this.filterOptions.municipalities,
          placeholder: "Seleccionar",
          fieldName: "name",
          fieldKey: "id",
          class: "col-12 col-md-3",
          isAdvanced: true
        },
        {
          name: "school",
          component: "CustomDropDown",
          label: "Escuela:",
          value: this.filterModel.school,
          options: this.filterOptions.schools,
          placeholder: "Seleccionar",
          fieldName: "name",
          fieldKey: "id",
          class: "col-12 col-md-3",
          isAdvanced: true
        },
        {
          name: "studentSieId",
          component: "CustomInput",
          label: "SIE:",
          icon: "fa fa-search color-orange",
          leftIcon: true,
          placeholder: "Buscar por número de SIE",
          class: "col-12 col-md-3",
          isAdvanced: true
        },
        {
          name: "service",
          component: "CustomDropDown",
          label: "Tipo de Servicio:",
          value: this.filterModel.service,
          options: this.filterOptions.services,
          placeholder: "Seleccionar",
          fieldName: "name",
          fieldKey: "id",
          class: "col-12 col-md-4",
          isAdvanced: true,
          visible: this.showService
        }
      ];
    },
    showPagination() {
      return this.pagination.totalItemCount > this.pagination.pageSize;
    },
    showService() {
      return this.filterModel.stipulation?.id === stipulationTypes.St40
    }
  },
  created() {
    hubService.onEvent(serverEvents.ReceiveQueueReportMessage, this.updateQueuedReportInfo)
  },

  async mounted() {
    await this.getInitFilters();
   },

  methods: {
    updateQueuedReportInfo(reportInfo) {
      this.queuedReportInfo = reportInfo;
    },

    async onDownloadHandler(executionLogId) {
      await _downloadQueuedReport(executionLogId);
    },

    async onCancelHandler(executionLogId) {
      _cancelQueuedReport(executionLogId)
        .then(() => this.updateQueuedReportInfo(null));
    },

    async queueManagementReport() {
      const isValid = await this.$refs.filterManagerRef.$refs.formValidator.validate();
      if (!isValid) {
        this.ShowToast("Alerta", "Favor de llenar los campos requeridos.", "error");
        return;
      }

      const filterModel = this.filterModel;
      const payload = {
        academicYearId: filterModel.academicYear?.id,
        serviceId: filterModel.service?.id,
        complianceStatusId: filterModel.status?.id,
        centerId: filterModel.center?.id,
        municipalityId: filterModel.municipality?.id,
        schoolId: filterModel.school?.id,
        studentSieId: +filterModel.studentSieId || null,
        StipulationType: filterModel.stipulation?.id,
      };
      _queueComplianceManagementReport(payload)
        .then(() => {
          this.ShowToast("Éxito", "El reporte ha sido programado exitosamente.", "success");
        });
    },
    async getInitFilters() {
      const result = (await _getInitFilters()).data;
      this.filterOptions = {
        ...this.filterOptions,
        ...result
      };
      this.updateQueuedReportInfo(result.queuedReportInfo)
    },
    async onAcademicYearChangeHandler(value) {
      this.filterOptions = {
        ...this.filterOptions,
        centers: [],
        municipalities: [],
        schools: []
      };
      this.filterModel = {
        ...this.filterModel,
        center: null,
        municipality: null,
        school: null,
        studentSieId: null,
        service: null
      };

      if (!value?.id) return;
      this.filterOptions.centers = (await _getCenters(value.id)).data;
    },
    async onCenterChangeHandler(value) {
      const academicYearId = this.filterModel.academicYear?.id;

      this.filterOptions = {
        ...this.filterOptions,
        municipalities: [],
        schools: []
      };

      this.filterModel = {
        ...this.filterModel,
        municipality: null,
        school: null
      };

      if (!value || !academicYearId) return;

      this.filterOptions.municipalities = (
        await _getMunicipalities(academicYearId, value.id)
      ).data;
    },
    async onMunicipalityChangeHandler(value) {
      const academicYearId = this.filterModel.academicYear?.id;
      const centerId = this.filterModel.center?.id;

      this.filterOptions = {
        ...this.filterOptions,
        schools: []
      };

      this.filterModel = {
        ...this.filterModel,
        school: null
      };

      if (!value || !academicYearId || !centerId) return;

      this.filterOptions.schools = (
        await _getSchools(academicYearId, centerId, value.id)
      ).data;
    },
    async onSearchHandler(filterModel, pageIndex = 1) {
      const isValid = await this.$refs.filterManagerRef.$refs.formValidator.validate();
      if (!isValid) {
        this.ShowToast("Alerta", "Información Incompleta.", "error");
        return;
      }
      const payload = {
        academicYearId: filterModel.academicYear?.id,
        serviceId: filterModel.service?.id,
        complianceStatusId: filterModel.status?.id,
        centerId: filterModel.center?.id,
        municipalityId: filterModel.municipality?.id,
        schoolId: filterModel.school?.id,
        studentSieId: +filterModel.studentSieId || null,
        StipulationType: filterModel.stipulation?.id,
      };
      const result = (
        await _searchRelatedServices(
          payload,
          pageIndex,
          this.pagination.pageSize
        )
      ).data;
      this.result = result.data.map(x => ({ ...x, isOpen: false }));
      this.pagination = {
        ...this.pagination,
        totalItemCount: result.totalItemCount,
        pageCount: result.pageCount,
        currentPage: result.currentPage,
        count: result.count,
      };
    },
    async goToPageHandler(page) {
      await this.onSearchHandler(this.filterModel, page);
    },
    async onSaveManageInformationHandler(value, model) {
      if (value) {
        let payload = {
          id: value.id,
          stipulationType: value.stipulationId
        };

        if (typeof model !== "undefined") {
          payload = {
            ...payload,
            complianceDate: model.date,
            complianceStatusReasonId: model.selectedReason?.id,
            complianceComment: model.comment
          };
        }

        let result;

        if (typeof model === "undefined") {
          result = (await _accomplishCompliance(payload)).data;
        } else if (
          model?.serviceViewTypeId ===
          relatedServiceViewTypes.ManageInfoAccomplish
        ) {
          result = (await _accomplishCompliance(payload)).data;
        } else if (
          model?.serviceViewTypeId ===
          relatedServiceViewTypes.Deny
        ) {
          result = (await _denyCompliance(payload)).data;
        } else {
          result = (await _excludeCompliance(payload)).data;
        }

        if (result) {
          await this.onSearchHandler(
            this.filterModel,
            this.pagination.currentPage
          );

          let message = "La información ha sido cumplida exitosamente.";

          message =
            model?.serviceViewTypeId !==
            relatedServiceViewTypes.ManageInfoAccomplish;
          ("La información ha sido excluida exitosamente.");

          this.ShowToast("Proceso exitoso.", message, "success");
        }
      }
    },
    async onPendingApprovalChangeStatusHandler(value){
      try{
        let payload = {
          id: value.id,
          stipulationType: value.stipulationId
        };

        await _pendingApprovalStatusCompliance(payload);
        
        this.ShowToast("Proceso exitoso.", "La estipulación ha sido modificada exitosamente", "success");

        await this.onSearchHandler(
            this.filterModel,
            this.pagination.currentPage
          );
      }
      catch(err){
        this.ShowToast('', err?.message, 'error');        
      }                   
    },
    async onStipulationChangeHandler(value) {
     if (value == null && value == undefined) {
      this.filterOptions = {
        ...this.filterOptions,
        municipalities: [],
        schools: []
      };
      this.filterModel = {
        ...this.filterModel,
        center: null,
        municipality: null,
        school: null,
        studentSieId: null,
        service: null
      };
     } else {
        this.filterOptions = {
          ...this.filterOptions,
          centers: [],
          municipalities: [],
          schools: []
        };
        this.filterModel = {
          ...this.filterModel,
          center: null,
          municipality: null,
          school: null,
          studentSieId: null,
          service: null
        };

        if (!value?.id) return;
        this.filterOptions.centers = (await _getCenters(value.id)).data;
     }

      const payload = {
        StipulationType: value.id,
      };
      let result;
      result = (
        await _hasAdvancedFilter(
          payload
        )
      ).data;
      this.openAdvanced = result;
    }
  }

};
</script>

<style></style>
